<!-- eslint-disable vue/singleline-html-element-content-newline -->
<template>
  <h1 class="text-white text-center text-3xl font-bold">Восток Телеком</h1>
</template>
